import state from '@/stores/cases/state.js'
import mutations from '@/stores/cases/mutations.js'
import actions from '@/stores/cases/actions.js'

export default {
  state,
  mutations,
  actions
}
